export default "__VITE_ASSET__CC_g00rK__"